import { render } from "./CustomerAttributePills.vue?vue&type=template&id=4874d9a4"
import script from "./CustomerAttributePills.vue?vue&type=script&lang=js"
export * from "./CustomerAttributePills.vue?vue&type=script&lang=js"

import "./CustomerAttributePills.vue?vue&type=style&index=0&id=4874d9a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__